module.exports = __webpack_public_path__ + "static/media/dentista.20e02e4c.png";